module.exports = __webpack_public_path__ + "img/horizontal_3_2_9005.1bb6487f.png";